import { STUDENT_COURSE_VALIDATION } from '../../api/endpoints';
import request from '../../api/request';
import {
  CourseValidationInternalStudyPlanEnrollmentBase,
  CourseValidationInternalStudyPlanEnrollmentCurriculum,
  CreateValidationFormData,
  CreateValidationRequest,
} from './types';

export function getCourseValidationInternalStudyPlanEnrollment(
  studyPlanEnrollmentId: number | string,
) {
  const url = STUDENT_COURSE_VALIDATION.INTERNAL.STUDY_PLAN_ENROLLMENT(
    studyPlanEnrollmentId,
  );
  return request<CourseValidationInternalStudyPlanEnrollmentBase>(url, {
    method: 'get',
  });
}

export async function getCourseValidationInternalStudyPlanEnrollmentCurriculum(
  studyPlanEnrollmentId: number | string,
) {
  const url = STUDENT_COURSE_VALIDATION.INTERNAL.CURRICULUM(
    studyPlanEnrollmentId,
  );
  return request<CourseValidationInternalStudyPlanEnrollmentCurriculum>(url, {
    method: 'get',
  });
}

export const createValidation = async (data: CreateValidationRequest) =>
  request<void>(STUDENT_COURSE_VALIDATION.GENERIC.CREATE, {
    method: 'POST',
    data: data,
  });

export const getFormData = async ({
  studyPlanEnrollmentId,
}: {
  studyPlanEnrollmentId: number | string;
}) =>
  request<CreateValidationFormData>(
    STUDENT_COURSE_VALIDATION.GENERIC.FORM_DATA(studyPlanEnrollmentId),
  );
